import ReceiptIcon from "@mui/icons-material/Receipt";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import TourIcon from "@mui/icons-material/Tour";
import { AppBar, Box, Button, Stack, Toolbar, Typography } from "@mui/material";
import React from "react";

import { Link } from "react-router-dom";
import GlobalContext from "../../global-context";
import { colors } from "../../helpers/colors";
import Logo from "../Logo";
import CurrencySwitcher from "./CurrencySwitcher";
import ProfileMenu from "./ProfileMenu";

export default function TopBar() {
  const globalContext = React.useContext(GlobalContext);
  if (!globalContext.loggedIn) return null;

  return (
    <AppBar
      sx={{ backgroundColor: colors.coralRed }}
      position="fixed"
      elevation={0}
    >
      <Toolbar
        sx={{
          maxWidth: "1300px",
          width: "95%",
          margin: "0 auto",
        }}
      >
        <Typography variant="h6">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Logo color={colors.white} size={40} />
          </Stack>
        </Typography>
        <Box sx={{ marginLeft: "40px", flexGrow: 1, width: "100%" }}>
          <Stack direction="row" spacing={2}>
            <Button
              sx={{ color: "white", fontWeight: "bold" }}
              startIcon={<TourIcon />}
              component={Link}
              to="/tours"
            >
              Tours
            </Button>
            <Button
              sx={{ color: "white", fontWeight: "bold" }}
              startIcon={<ReceiptIcon />}
              component={Link}
              to="/bookings"
            >
              Bookings
            </Button>
            <Button
              sx={{ color: "white", fontWeight: "bold" }}
              startIcon={<NewspaperIcon />}
              component={Link}
              to="/news"
            >
              News
            </Button>
          </Stack>
        </Box>
        <Stack direction="row" spacing={2} alignItems="center">
          <CurrencySwitcher />
          <ProfileMenu />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
